(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["sr-Cyrl-XK"] = {
            name: "sr-Cyrl-XK",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Euro",
                    abbr: "EUR",
                    pattern: ["-n $","n $"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "€"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["недеља","понедељак","уторак","среда","четвртак","петак","субота"],
                        namesAbbr: ["нед.","пон.","ут.","ср.","чет.","пет.","суб."],
                        namesShort: ["не","по","ут","ср","че","пе","су"]
                    },
                    months: {
                        names: ["јануар","фебруар","март","април","мај","јун","јул","август","септембар","октобар","новембар","децембар"],
                        namesAbbr: ["јан.","феб.","март","апр.","мај","јун","јул","авг.","септ.","окт.","нов.","дец."]
                    },
                    AM: ["пре подне","пре подне","ПРЕ ПОДНЕ"],
                    PM: ["по подне","по подне","ПО ПОДНЕ"],
                    patterns: {
                        d: "d.M.yyyy.",
                        D: "dddd, dd. MMMM yyyy.",
                        F: "dddd, dd. MMMM yyyy. HH:mm:ss",
                        g: "d.M.yyyy. HH:mm",
                        G: "d.M.yyyy. HH:mm:ss",
                        m: "d. MMMM",
                        M: "d. MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "HH:mm",
                        T: "HH:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy.",
                        Y: "MMMM yyyy."
                    },
                    "/": ".",
                    ":": ":",
                    firstDay: 1
                }
            }
        };
    })();

}));
